var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _circle, _circle2, _circle3, _circle4, _circle5, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCheckmarkProgress = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.7225 23.5008C51.417 31.6317 48.6311 42.0288 40.5001 46.7232C32.3692 51.4175 21.9722 48.6317 17.2778 40.5008C15.7293 37.8186 14.9947 34.8898 14.9974 32.0005H14.9776C14.9924 31.8358 15 31.669 15 31.5005C15 28.4629 12.5376 26.0005 9.5 26.0005C6.46243 26.0005 4 28.4629 4 31.5005C4 31.669 4.00758 31.8358 4.02242 32.0005H3.99562C3.99112 36.7593 5.20102 41.5831 7.75157 46.0008C7.80941 46.1009 7.86777 46.2006 7.92665 46.2998C7.95093 46.3447 7.97591 46.3893 8.00157 46.4338C8.06826 46.5493 8.13852 46.6615 8.21211 46.7703C15.9896 59.3132 32.2097 63.6593 45.2167 56.6856C45.3348 56.6282 45.4517 56.5662 45.5673 56.4995C45.6117 56.4738 45.6557 56.4476 45.6991 56.4209C45.7997 56.3645 45.9001 56.3073 46.0003 56.2495C59.3924 48.5175 63.9808 31.3929 56.2488 18.0008C56.191 17.9006 56.1326 17.8009 56.0737 17.7017C56.0494 17.6569 56.0245 17.6122 55.9988 17.5678C55.9321 17.4522 55.8618 17.34 55.7882 17.2311C47.8537 4.43514 31.1324 0.170104 18.0001 7.75206L18.0113 7.77148C17.8613 7.84097 17.7131 7.91779 17.5671 8.00206C14.9365 9.52084 14.0352 12.8846 15.554 15.5152C17.0727 18.1458 20.4365 19.0471 23.0671 17.5283C23.2131 17.4441 23.3537 17.3541 23.4889 17.2589L23.5001 17.2783C31.6311 12.5839 42.0281 15.3698 46.7225 23.5008Z",
    fill: "url(#paint0_radial_119_93357)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.7225 23.5008C51.417 31.6317 48.6311 42.0288 40.5001 46.7232C32.3692 51.4175 21.9722 48.6317 17.2778 40.5008C15.7293 37.8186 14.9947 34.8898 14.9974 32.0005H14.9776C14.9924 31.8358 15 31.669 15 31.5005C15 28.4629 12.5376 26.0005 9.5 26.0005C6.46243 26.0005 4 28.4629 4 31.5005C4 31.669 4.00758 31.8358 4.02242 32.0005H3.99562C3.99112 36.7593 5.20102 41.5831 7.75157 46.0008C7.80941 46.1009 7.86777 46.2006 7.92665 46.2998C7.95093 46.3447 7.97591 46.3893 8.00157 46.4338C8.06826 46.5493 8.13852 46.6615 8.21211 46.7703C15.9896 59.3132 32.2097 63.6593 45.2167 56.6856C45.3348 56.6282 45.4517 56.5662 45.5673 56.4995C45.6117 56.4738 45.6557 56.4476 45.6991 56.4209C45.7997 56.3645 45.9001 56.3073 46.0003 56.2495C59.3924 48.5175 63.9808 31.3929 56.2488 18.0008C56.191 17.9006 56.1326 17.8009 56.0737 17.7017C56.0494 17.6569 56.0245 17.6122 55.9988 17.5678C55.9321 17.4522 55.8618 17.34 55.7882 17.2311C47.8537 4.43514 31.1324 0.170104 18.0001 7.75206L18.0113 7.77148C17.8613 7.84097 17.7131 7.91779 17.5671 8.00206C14.9365 9.52084 14.0352 12.8846 15.554 15.5152C17.0727 18.1458 20.4365 19.0471 23.0671 17.5283C23.2131 17.4441 23.3537 17.3541 23.4889 17.2589L23.5001 17.2783C31.6311 12.5839 42.0281 15.3698 46.7225 23.5008Z",
    fill: "url(#paint1_linear_119_93357)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.7225 23.5008C51.417 31.6317 48.6311 42.0288 40.5001 46.7232C32.3692 51.4175 21.9722 48.6317 17.2778 40.5008C15.7293 37.8186 14.9947 34.8898 14.9974 32.0005H14.9776C14.9924 31.8358 15 31.669 15 31.5005C15 28.4629 12.5376 26.0005 9.5 26.0005C6.46243 26.0005 4 28.4629 4 31.5005C4 31.669 4.00758 31.8358 4.02242 32.0005H3.99562C3.99112 36.7593 5.20102 41.5831 7.75157 46.0008C7.80941 46.1009 7.86777 46.2006 7.92665 46.2998C7.95093 46.3447 7.97591 46.3893 8.00157 46.4338C8.06826 46.5493 8.13852 46.6615 8.21211 46.7703C15.9896 59.3132 32.2097 63.6593 45.2167 56.6856C45.3348 56.6282 45.4517 56.5662 45.5673 56.4995C45.6117 56.4738 45.6557 56.4476 45.6991 56.4209C45.7997 56.3645 45.9001 56.3073 46.0003 56.2495C59.3924 48.5175 63.9808 31.3929 56.2488 18.0008C56.191 17.9006 56.1326 17.8009 56.0737 17.7017C56.0494 17.6569 56.0245 17.6122 55.9988 17.5678C55.9321 17.4522 55.8618 17.34 55.7882 17.2311C47.8537 4.43514 31.1324 0.170104 18.0001 7.75206L18.0113 7.77148C17.8613 7.84097 17.7131 7.91779 17.5671 8.00206C14.9365 9.52084 14.0352 12.8846 15.554 15.5152C17.0727 18.1458 20.4365 19.0471 23.0671 17.5283C23.2131 17.4441 23.3537 17.3541 23.4889 17.2589L23.5001 17.2783C31.6311 12.5839 42.0281 15.3698 46.7225 23.5008Z",
    fill: "url(#paint2_radial_119_93357)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.7225 23.5008C51.417 31.6317 48.6311 42.0288 40.5001 46.7232C32.3692 51.4175 21.9722 48.6317 17.2778 40.5008C15.7293 37.8186 14.9947 34.8898 14.9974 32.0005H14.9776C14.9924 31.8358 15 31.669 15 31.5005C15 28.4629 12.5376 26.0005 9.5 26.0005C6.46243 26.0005 4 28.4629 4 31.5005C4 31.669 4.00758 31.8358 4.02242 32.0005H3.99562C3.99112 36.7593 5.20102 41.5831 7.75157 46.0008C7.80941 46.1009 7.86777 46.2006 7.92665 46.2998C7.95093 46.3447 7.97591 46.3893 8.00157 46.4338C8.06826 46.5493 8.13852 46.6615 8.21211 46.7703C15.9896 59.3132 32.2097 63.6593 45.2167 56.6856C45.3348 56.6282 45.4517 56.5662 45.5673 56.4995C45.6117 56.4738 45.6557 56.4476 45.6991 56.4209C45.7997 56.3645 45.9001 56.3073 46.0003 56.2495C59.3924 48.5175 63.9808 31.3929 56.2488 18.0008C56.191 17.9006 56.1326 17.8009 56.0737 17.7017C56.0494 17.6569 56.0245 17.6122 55.9988 17.5678C55.9321 17.4522 55.8618 17.34 55.7882 17.2311C47.8537 4.43514 31.1324 0.170104 18.0001 7.75206L18.0113 7.77148C17.8613 7.84097 17.7131 7.91779 17.5671 8.00206C14.9365 9.52084 14.0352 12.8846 15.554 15.5152C17.0727 18.1458 20.4365 19.0471 23.0671 17.5283C23.2131 17.4441 23.3537 17.3541 23.4889 17.2589L23.5001 17.2783C31.6311 12.5839 42.0281 15.3698 46.7225 23.5008Z",
    fill: "url(#paint3_radial_119_93357)",
    fillOpacity: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.7225 23.5008C51.417 31.6317 48.6311 42.0288 40.5001 46.7232C32.3692 51.4175 21.9722 48.6317 17.2778 40.5008C15.7293 37.8186 14.9947 34.8898 14.9974 32.0005H14.9776C14.9924 31.8358 15 31.669 15 31.5005C15 28.4629 12.5376 26.0005 9.5 26.0005C6.46243 26.0005 4 28.4629 4 31.5005C4 31.669 4.00758 31.8358 4.02242 32.0005H3.99562C3.99112 36.7593 5.20102 41.5831 7.75157 46.0008C7.80941 46.1009 7.86777 46.2006 7.92665 46.2998C7.95093 46.3447 7.97591 46.3893 8.00157 46.4338C8.06826 46.5493 8.13852 46.6615 8.21211 46.7703C15.9896 59.3132 32.2097 63.6593 45.2167 56.6856C45.3348 56.6282 45.4517 56.5662 45.5673 56.4995C45.6117 56.4738 45.6557 56.4476 45.6991 56.4209C45.7997 56.3645 45.9001 56.3073 46.0003 56.2495C59.3924 48.5175 63.9808 31.3929 56.2488 18.0008C56.191 17.9006 56.1326 17.8009 56.0737 17.7017C56.0494 17.6569 56.0245 17.6122 55.9988 17.5678C55.9321 17.4522 55.8618 17.34 55.7882 17.2311C47.8537 4.43514 31.1324 0.170104 18.0001 7.75206L18.0113 7.77148C17.8613 7.84097 17.7131 7.91779 17.5671 8.00206C14.9365 9.52084 14.0352 12.8846 15.554 15.5152C17.0727 18.1458 20.4365 19.0471 23.0671 17.5283C23.2131 17.4441 23.3537 17.3541 23.4889 17.2589L23.5001 17.2783C31.6311 12.5839 42.0281 15.3698 46.7225 23.5008Z",
    fill: "url(#paint4_radial_119_93357)",
    fillOpacity: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.75 18.375C51.75 18.5821 51.5821 18.75 51.375 18.75C51.1679 18.75 51 18.5821 51 18.375C51 18.1679 51.1679 18 51.375 18C51.5821 18 51.75 18.1679 51.75 18.375Z",
    fill: "#EFE269"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34 10.5C34 10.7761 33.7761 11 33.5 11C33.2239 11 33 10.7761 33 10.5C33 10.2239 33.2239 10 33.5 10C33.7761 10 34 10.2239 34 10.5Z",
    fill: "#EFE269"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41 13.5C41 13.7761 40.7761 14 40.5 14C40.2239 14 40 13.7761 40 13.5C40 13.2239 40.2239 13 40.5 13C40.7761 13 41 13.2239 41 13.5Z",
    fill: "#EFE269"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44 13.5C44 13.7761 43.7761 14 43.5 14C43.2239 14 43 13.7761 43 13.5C43 13.2239 43.2239 13 43.5 13C43.7761 13 44 13.2239 44 13.5Z",
    fill: "#EFE269"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M56 27.5C56 27.7761 55.7761 28 55.5 28C55.2239 28 55 27.7761 55 27.5C55 27.2239 55.2239 27 55.5 27C55.7761 27 56 27.2239 56 27.5Z",
    fill: "#EFE269"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.2998,
    cy: 12.7998,
    r: 5.5,
    fill: "url(#paint5_radial_119_93357)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.2998,
    cy: 12.7998,
    r: 5.5,
    fill: "url(#paint6_radial_119_93357)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.2998,
    cy: 12.7998,
    r: 5.5,
    fill: "url(#paint7_radial_119_93357)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.2998,
    cy: 12.7998,
    r: 5.5,
    fill: "url(#paint8_radial_119_93357)",
    fillOpacity: 0.8
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.2998,
    cy: 12.7998,
    r: 5.5,
    fill: "url(#paint9_radial_119_93357)",
    fillOpacity: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5645 40.8751C31.5074 40.9419 31.4449 41.0093 31.3797 41.0721C30.1214 42.3093 28.0804 42.3093 26.8221 41.0721L20.9437 35.2941C19.6854 34.0575 19.6854 32.0532 20.9437 30.816C22.202 29.5795 24.2403 29.5795 25.4986 30.816L28.1411 33.4128C28.4478 33.7142 28.9574 33.6693 29.2046 33.3191L36.2362 23.3614C36.7199 22.6764 37.4293 22.2371 38.1956 22.0728C39.0381 21.8926 39.954 22.0434 40.7204 22.5649C42.1825 23.5617 42.544 25.534 41.5303 26.9709L32.1678 40.2315C31.9939 40.4785 31.79 40.6935 31.5645 40.8751Z",
    fill: "#D9D9D9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5645 40.8751C31.5074 40.9419 31.4449 41.0093 31.3797 41.0721C30.1214 42.3093 28.0804 42.3093 26.8221 41.0721L20.9437 35.2941C19.6854 34.0575 19.6854 32.0532 20.9437 30.816C22.202 29.5795 24.2403 29.5795 25.4986 30.816L28.1411 33.4128C28.4478 33.7142 28.9574 33.6693 29.2046 33.3191L36.2362 23.3614C36.7199 22.6764 37.4293 22.2371 38.1956 22.0728C39.0381 21.8926 39.954 22.0434 40.7204 22.5649C42.1825 23.5617 42.544 25.534 41.5303 26.9709L32.1678 40.2315C31.9939 40.4785 31.79 40.6935 31.5645 40.8751Z",
    fill: "#4ECBFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5645 40.8751C31.5074 40.9419 31.4449 41.0093 31.3797 41.0721C30.1214 42.3093 28.0804 42.3093 26.8221 41.0721L20.9437 35.2941C19.6854 34.0575 19.6854 32.0532 20.9437 30.816C22.202 29.5795 24.2403 29.5795 25.4986 30.816L28.1411 33.4128C28.4478 33.7142 28.9574 33.6693 29.2046 33.3191L36.2362 23.3614C36.7199 22.6764 37.4293 22.2371 38.1956 22.0728C39.0381 21.8926 39.954 22.0434 40.7204 22.5649C42.1825 23.5617 42.544 25.534 41.5303 26.9709L32.1678 40.2315C31.9939 40.4785 31.79 40.6935 31.5645 40.8751Z",
    fill: "url(#paint10_linear_119_93357)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5645 40.8751C31.5074 40.9419 31.4449 41.0093 31.3797 41.0721C30.1214 42.3093 28.0804 42.3093 26.8221 41.0721L20.9437 35.2941C19.6854 34.0575 19.6854 32.0532 20.9437 30.816C22.202 29.5795 24.2403 29.5795 25.4986 30.816L28.1411 33.4128C28.4478 33.7142 28.9574 33.6693 29.2046 33.3191L36.2362 23.3614C36.7199 22.6764 37.4293 22.2371 38.1956 22.0728C39.0381 21.8926 39.954 22.0434 40.7204 22.5649C42.1825 23.5617 42.544 25.534 41.5303 26.9709L32.1678 40.2315C31.9939 40.4785 31.79 40.6935 31.5645 40.8751Z",
    fill: "url(#paint11_linear_119_93357)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5645 40.8751C31.5074 40.9419 31.4449 41.0093 31.3797 41.0721C30.1214 42.3093 28.0804 42.3093 26.8221 41.0721L20.9437 35.2941C19.6854 34.0575 19.6854 32.0532 20.9437 30.816C22.202 29.5795 24.2403 29.5795 25.4986 30.816L28.1411 33.4128C28.4478 33.7142 28.9574 33.6693 29.2046 33.3191L36.2362 23.3614C36.7199 22.6764 37.4293 22.2371 38.1956 22.0728C39.0381 21.8926 39.954 22.0434 40.7204 22.5649C42.1825 23.5617 42.544 25.534 41.5303 26.9709L32.1678 40.2315C31.9939 40.4785 31.79 40.6935 31.5645 40.8751Z",
    fill: "url(#paint12_linear_119_93357)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5645 40.8751C31.5074 40.9419 31.4449 41.0093 31.3797 41.0721C30.1214 42.3093 28.0804 42.3093 26.8221 41.0721L20.9437 35.2941C19.6854 34.0575 19.6854 32.0532 20.9437 30.816C22.202 29.5795 24.2403 29.5795 25.4986 30.816L28.1411 33.4128C28.4478 33.7142 28.9574 33.6693 29.2046 33.3191L36.2362 23.3614C36.7199 22.6764 37.4293 22.2371 38.1956 22.0728C39.0381 21.8926 39.954 22.0434 40.7204 22.5649C42.1825 23.5617 42.544 25.534 41.5303 26.9709L32.1678 40.2315C31.9939 40.4785 31.79 40.6935 31.5645 40.8751Z",
    fill: "url(#paint13_radial_119_93357)",
    fillOpacity: 0.62
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5645 40.8751C31.5074 40.9419 31.4449 41.0093 31.3797 41.0721C30.1214 42.3093 28.0804 42.3093 26.8221 41.0721L20.9437 35.2941C19.6854 34.0575 19.6854 32.0532 20.9437 30.816C22.202 29.5795 24.2403 29.5795 25.4986 30.816L28.1411 33.4128C28.4478 33.7142 28.9574 33.6693 29.2046 33.3191L36.2362 23.3614C36.7199 22.6764 37.4293 22.2371 38.1956 22.0728C39.0381 21.8926 39.954 22.0434 40.7204 22.5649C42.1825 23.5617 42.544 25.534 41.5303 26.9709L32.1678 40.2315C31.9939 40.4785 31.79 40.6935 31.5645 40.8751Z",
    fill: "url(#paint14_radial_119_93357)",
    fillOpacity: 0.6
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5645 40.8751C31.5074 40.9419 31.4449 41.0093 31.3797 41.0721C30.1214 42.3093 28.0804 42.3093 26.8221 41.0721L20.9437 35.2941C19.6854 34.0575 19.6854 32.0532 20.9437 30.816C22.202 29.5795 24.2403 29.5795 25.4986 30.816L28.1411 33.4128C28.4478 33.7142 28.9574 33.6693 29.2046 33.3191L36.2362 23.3614C36.7199 22.6764 37.4293 22.2371 38.1956 22.0728C39.0381 21.8926 39.954 22.0434 40.7204 22.5649C42.1825 23.5617 42.544 25.534 41.5303 26.9709L32.1678 40.2315C31.9939 40.4785 31.79 40.6935 31.5645 40.8751Z",
    fill: "url(#paint15_radial_119_93357)",
    fillOpacity: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_119_93357",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.4995 7) rotate(100.345) scale(64.041 102.43)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.147807,
    stopColor: "#1296FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.307586,
    stopColor: "#31D2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#31D2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.642219,
    stopColor: "#CDEC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822917,
    stopColor: "#CDEC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E7E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_119_93357",
    x1: 14.4995,
    y1: 49,
    x2: 35.9868,
    y2: 34.9805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.623464,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733059,
    stopColor: "#E7E7E7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_119_93357",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.9995 46.5) rotate(67.7965) scale(26.4622 26.485)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.282887,
    stopColor: "#FFF4CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.870451,
    stopColor: "#FFF4CE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_119_93357",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.9995 38.5) rotate(138.205) scale(44.2634 42.1569)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.628419,
    stopColor: "#0056BB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732286,
    stopColor: "#0056BB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_119_93357",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.9995 38) rotate(133.831) scale(17.3277 15.5989)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D7D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.270833,
    stopColor: "#8D7D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786458,
    stopColor: "#8D7D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D7D7D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_119_93357",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.122 11.2239) rotate(120.689) scale(10.394)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.103226,
    stopColor: "#C58FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.322917,
    stopColor: "#9D50EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#7B30EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#CB5285"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_119_93357",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.1947 10.4246) rotate(104.486) scale(8.13412)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAB0F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806053,
    stopColor: "#D1A5EA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_119_93357",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.34 10.2066) rotate(123.541) scale(3.87981)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDDAFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573279,
    stopColor: "#D8BDEF",
    stopOpacity: 0.57836
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC95DC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_119_93357",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.2998 12.7998) rotate(97.8153) scale(9.7631)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.446038,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841379,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_119_93357",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.1101 18.2998) rotate(-90) scale(3.98276 7.87069)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB3BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE625D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_119_93357",
    x1: 24.5005,
    y1: 40.0545,
    x2: 29.0097,
    y2: 35.3501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ECBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276128,
    stopColor: "#0070DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.529185,
    stopColor: "#0083F5",
    stopOpacity: 0.315315
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77314,
    stopColor: "#4ECBFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_119_93357",
    x1: 20.5204,
    y1: 33.4784,
    x2: 23.2823,
    y2: 34.8128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007EEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F9EFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_119_93357",
    x1: 32.959,
    y1: 38.2113,
    x2: 29.3507,
    y2: 35.6334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0070DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484391,
    stopColor: "#0083F5",
    stopOpacity: 0.428977
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.592846,
    stopColor: "#0083F5",
    stopOpacity: 0.236848
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ECBFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_119_93357",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.9788 32.0001) rotate(38.1244) scale(4.25615 1.53918)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395833,
    stopColor: "white",
    stopOpacity: 0.458333
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98096,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_119_93357",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.8921 34.2004) rotate(-137.154) scale(5.27833 2.00793)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCF2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#BCF2FF",
    stopOpacity: 0.442708
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCF2FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_119_93357",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.5376 26.0686) rotate(129.141) scale(6.32029 2.47045)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCF2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541007,
    stopColor: "#BCF2FF",
    stopOpacity: 0.458333
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCF2FF",
    stopOpacity: 0
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCheckmarkProgress, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Checkmark Progress.d89dcb13.svg";
export { ForwardRef as ReactComponent };